import { render, staticRenderFns } from "./AppElement.vue?vue&type=template&id=7b1a248d&scoped=true"
import script from "./AppElement.vue?vue&type=script&lang=js"
export * from "./AppElement.vue?vue&type=script&lang=js"
import style0 from "./AppElement.vue?vue&type=style&index=0&id=7b1a248d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a248d",
  null
  
)

export default component.exports